import { PERSONA_LABELS } from '../canonical-personas.js';
import { PERSONA_ACCESS_PROFILE_REGISTRY } from './persona-access-profile.registry.js';
const OPERATION_BUNDLE_ID_TO_PERMISSION_BUNDLE_ID = {
    'platform-root': 'platform.root',
    'platform-admin': 'platform.admin',
    'platform-read': 'platform.user',
    'organization-admin': 'organization.admin',
    'organization-user-base': 'organization.user.base',
    'client-self-service': 'organization.client.base',
};
export const SYSTEM_ROLES = Object.values(PERSONA_ACCESS_PROFILE_REGISTRY).map((profile) => ({
    code: `${profile.persona}_PERSONA`,
    name: PERSONA_LABELS[profile.persona],
    persona: profile.persona,
    defaultAal: profile.authentication.defaultAal,
    permissionBundleIds: profile.access.defaultOperationBundleIds.map((bundleId) => OPERATION_BUNDLE_ID_TO_PERMISSION_BUNDLE_ID[bundleId] ?? bundleId),
}));
export const PERSONA_TO_SYSTEM_ROLE = SYSTEM_ROLES.reduce((acc, role) => {
    acc[role.persona] = role;
    return acc;
}, {});
export function getSystemRoleByPersona(persona) {
    const role = PERSONA_TO_SYSTEM_ROLE[persona];
    if (!role) {
        throw new Error(`No canonical system role for persona ${persona}`);
    }
    return role;
}
